import React, { useEffect } from "react";
import { COOKIES, SCREEN_PATHS } from "../../constants";
import Cookies from "js-cookie";
import { useAuth0 } from "@auth0/auth0-react";
import { Loading } from "views/shared/Loading";
import { useNavigate } from "react-router-dom";

export const SignOut = (): JSX.Element => {
  const auth0 = useAuth0()
  const navigate = useNavigate()

  useEffect(() => {
    (async () => {
      if (auth0?.isLoading) {
        console.log("auth0 is loading")
        return
      }

      Cookies.remove(COOKIES.authToken)
      await auth0.logout({logoutParams: { returnTo: window.location.origin }})
    })()
  }, [auth0?.isLoading]);

  return <Loading />;
};
